export default {
	props:{
		rooms:{type:Array, default(){return [];} }, //all available rooms
		ratePlans:{type:Array, default(){return [];} }, //all available rate plans
		mealPlans:{type:Array, default(){return [];} }, //all available meal plans
		selectedRooms:{type:Array, default(){return [];} },
		selectedRatePlans:{type:Array, default(){return [];} },
		selectedMealPlans:{type:Array, default(){return [];} },
	},
	data(){
		return {
			show: false,
			innerSelectedRooms:[],
			innerSelectedRatePlans:[],
			innerSelectedMealPlans:[],
		}
	},
	watch: {
		selectedRooms:{
			immediate: true,
			handler(val){
				const res = [];
				if(val){
					for(const el of this.rooms){
						if(val.includes(el.id)){ res.push(el.id); }
					}
				}
				this.innerSelectedRooms = res;
				if(val && val.length!==this.innerSelectedRooms.length){
					this.onChange('rooms');
				}
			},
		},
		selectedRatePlans:{
			immediate: true,
			handler(val){
				const res = [];
				if(val){
					for(const el of this.ratePlans){
						if(val.includes(el.id)){ res.push(el.id); }
					}
				}
				this.innerSelectedRatePlans = res;
				if(val && val.length!==this.innerSelectedRatePlans.length){
					this.onChange('rate-plans');
				}
			},
		},
		selectedMealPlans:{
			immediate: true,
			handler(val){
				const res = [];
				if(val){
					for(const el of this.mealPlans){
						if(val.includes(el.id)){ res.push(el.id); }
					}
				}
				this.innerSelectedMealPlans = res;
				if(val && val.length!==this.innerSelectedMealPlans.length){
					this.onChange('meal-plans');
				}
			},
		},
	},
	computed:{
		roomsOptions(){
			const res = [];
			for(const el of this.rooms){
				let selected = this.innerSelectedRooms.includes(el.id);
				let disabled = (this.innerSelectedRatePlans.length ? this.innerSelectedRatePlans.filter(x => el.rate_plans_ids.includes(x)).length : 1)===0;
				res.push({label:el.name, value:el.id, selected:selected, disabled:disabled});
			}
			return res;
		},
		ratePlansOptions(){
			const res = [];
			for(const el of this.ratePlans){
				let selected = this.innerSelectedRatePlans.includes(el.id);
				let disabled = (this.innerSelectedRooms.length ? this.innerSelectedRooms.filter(x => el.rooms_ids.includes(x)).length : 1)===0;
				res.push({label:el.name, value:el.id, selected:selected, disabled:disabled});
			}
			return res;
		},
		mealPlansOptions(){
			const res = [];
			for(const el of this.mealPlans){
				let selected = this.innerSelectedMealPlans.includes(el.id);
				let disabled = (this.innerSelectedRatePlans.length ? this.innerSelectedRatePlans.filter(x => el.rate_plans_ids.includes(x)).length : 1)===0;
				res.push({label:el.name, value:el.id, selected:selected, disabled:disabled});
			}
			return res;
		},
		numItemsSelected(){
			return this.selectedRooms.length + this.innerSelectedRatePlans.length + this.innerSelectedMealPlans.length;
		}
	},
	methods: {
		onChange(type){
			if(type==='rooms'){
				this.$emit('update:selected-rooms', this.innerSelectedRooms);
			}
			else if(type==='rate-plans'){
				this.$emit('update:selected-rate-plans', this.innerSelectedRatePlans);
			}
			else if(type==='meal-plans'){
				this.$emit('update:selected-meal-plans', this.innerSelectedMealPlans);
			}
		},
	},
	template: `
<qit-dropdown-list-control class="qit-rooms-rates-filter" select-class="" @click-ok="$emit('click-ok')">
	<template v-slot:label>
		<div class="link__icon">
			<span class="qicon-1">filter</span>
			<span class="ctrl-label" v-t="'labelRoomsAndRatesFilter'"></span>
			<span v-if="numItemsSelected" class="num-selected">{{numItemsSelected}}</span>
		</div>
	</template>
	<template v-slot:content>
		<div class="qit-rooms-rates-filter-content">
			<div class="col col1">
				<div class="col-title"><span v-t="'rooms'"></span>:</div>
				<div v-for="(el,i) in roomsOptions" :key="i" class="col-item">
          <label :class="['custom-chbox', el.disabled?'disabled':'', el.selected?'selected':'']">
            <input type="checkbox" :value="el.value" v-model="innerSelectedRooms" :disabled="el.disabled" @change="onChange('rooms')"/>
						<span class="lbl-holder"><span class="lbl-holder-inner">{{el.label}}</span></span>
          </label>
				</div>
			</div>
			<div class="col col2">
        <div class="col-title"><span v-t="'ratePlans'"></span>:</div>
        <div v-for="(el,i) in ratePlansOptions" :key="i" class="col-item">
          <label :class="['custom-chbox', el.disabled?'disabled':'', el.selected?'selected':'']">
            <input type="checkbox" :value="el.value" v-model="innerSelectedRatePlans" :disabled="el.disabled" @change="onChange('rate-plans')"/>
            <span class="lbl-holder"><span class="lbl-holder-inner">{{el.label}}</span></span>
          </label>
				</div>
			</div>
      <div class="col col3">
        <div class="col-title"><span v-t="'mealPlan'"></span>:</div>
        <div v-for="(el,i) in mealPlansOptions" :key="i" class="col-item">
          <label :class="['custom-chbox', el.disabled?'disabled':'', el.selected?'selected':'']">
            <input type="checkbox" :value="el.value" v-model="innerSelectedMealPlans" :disabled="el.disabled" @change="onChange('meal-plans')"/>
            <span class="lbl-holder"><span class="lbl-holder-inner">{{el.label}}</span></span>
          </label>
        </div>
      </div>
		</div>
    <slot name="default"></slot>
	</template>
	<template v-slot:bottom="{onClickButtonOk}">
		<div class="bottom">
			<button type="button" class="button fill" @click="onClickButtonOk">OK</button>
		</div>
	</template>
</qit-dropdown-list-control>
`,
}